import { DialogActions, DialogContent } from "@material-ui/core";
import { Button } from "@nuorder/components";
import { formatMessage } from "lib/globalize-util";
import { Dialog } from "material-ui";
import React from "react";
import "./grid-control-alert.css";

interface Props {
    isAlertOpen: boolean;
    closeAlert: () => void;
}

const GridControlAlert = ({ isAlertOpen, closeAlert }: Props) => {
    return (
        <Dialog open={isAlertOpen} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogContent className="grid-control-alert-body">
                {formatMessage("Please disable Pivot mode in order to open the financial target grid")}
            </DialogContent>
            <DialogActions>
                <Button primary onClick={closeAlert} color="primary" autoFocus className="grid-control-alert-button">
                    {formatMessage("Ok")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default GridControlAlert;
